import axios from "axios";
import * as actionType from "../../constant/actionType";
export const SpecificWorkerDocumentsDashboard = (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
        },
        url: `${actionType.environment_url}/api/worker/SpecificWorkerDocumentsDashboard`,
        params: apiData
      });
      return response.data
      
    } catch (error) {
        return error.message  
    }
  };


  export const SpecificWorkerIndDashboard =
  (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/worker/SpecificWorkerIndDashboard`,
        params: apiData,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };
